const aboutPage = {
  "about.terms-of-use.title": "Términos de uso",
  "about.terms-of-use.description": "Al usar Be Your Best, aceptas nuestros Términos de uso.",
  "about.privacy.title": "Privacidad",
  "about.privacy.description": "Al usar Be Your Best, aceptas nuestra Política de privacidad.",
  "about.app-version": "Versión de la aplicación",
};

export const about = {
  ...aboutPage,
};